import { render, staticRenderFns } from "./voteList.vue?vue&type=template&id=77d69d6e&scoped=true&"
import script from "./voteList.vue?vue&type=script&lang=js&"
export * from "./voteList.vue?vue&type=script&lang=js&"
import style0 from "./voteList.vue?vue&type=style&index=0&id=77d69d6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d69d6e",
  null
  
)

export default component.exports